import React from "react";
import { useTransition, animated } from "@react-spring/web";

type PageTransitionProps = {
  children: React.ReactNode;
};

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {

  const transitions = useTransition(true, {
    from: { opacity: 0 },
    enter: {
      opacity: 1,
      backdropFilter: "blur(30px)",
      WebkitBackdropFilter: "blur(30px)",
    },
    leave: {
      backdropFilter: "blur(0px)",
      opacity: 0,
      WebkitBackdropFilter: "blur(0px)",
    },
    config: { tension: 280, friction: 60 },
  });

  return transitions((style, item) => {
      return (
        <animated.div
          style={{ ...style }}
          className={
            "h-screen w-full absolute top-0 left-0 z-10 bg-transparent ease-in-out transition transition-backdrop transition-opacity "
          }
        >
          {children}
        </animated.div>
      );
  });
};

export default PageTransition;
